import React from 'react';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';
import { useNavigate } from 'react-router-dom';

const systemImport = (name: string): Promise<any> =>
    (window as any).System.import(name);

// Mounts the @Smalljoys/PatientScreening MFE as a parcel.
// The parent route is /screening-v2/* so BrowserRouter inside the MFE
// (basename="/screening-v2") can handle all sub-routes without conflict.
const PatientScreeningParcel: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Parcel
            config={() => systemImport('@Smalljoys/PatientScreening')}
            mountParcel={mountRootParcel}
            basename="/screening-v2"
            onSessionExpired={() => navigate('/adminLoginV2')}
        />
    );
};

export default PatientScreeningParcel;
